import { Alert, IconButton } from '@components'
import type { PoentialHighQuality } from '@here/api'
import { A } from '@solidjs/router'
import { ArrowRight, Star } from 'lucide-solid'
import { Flex, Grid } from 'styled-system/jsx'

export default function (props: {
	poentialHighQuality: PoentialHighQuality & {
		setup: {
			id: string
			symbol: string
		}
	}
}) {
	return (
		<Alert.Root
			border="none"
			p={4}
		>
			<Alert.Icon asChild={(props) => <Star {...props} />} />
			<Alert.Content width="100%">
				<Grid gridTemplateColumns="1fr auto">
					<Grid>
						<Alert.Title>{props.poentialHighQuality.setup.symbol}</Alert.Title>
						<Alert.Description>{props.poentialHighQuality.message}</Alert.Description>
					</Grid>
					<Flex
						flexDirection="column"
						justifyContent="end"
					>
						<A href={`/setups/${props.poentialHighQuality.setup_id}`}>
							<IconButton
								height="6"
								width="6"
								colorPalette="tscGreen"
								variant="ghost"
							>
								<ArrowRight />
							</IconButton>
						</A>
					</Flex>
				</Grid>
			</Alert.Content>
		</Alert.Root>
	)
}
